import React from "react";
import { Form, Col } from "react-bootstrap";

import { ToolTip } from "../../../../Common/Tooltip/ToolTip";
import * as Constants from "../../../../../constants/Constants";
import { MerchantContactsFields } from "./MerchantContactsFields";

const MerchantContacts = ({
  merchantContact,
  merchantContactsIndex,
  onChangeMerchantContact,
  errors,
  handleValidate,
  primaryRole,
}) => {
  const getRole = (merchantContact, merchantContactsField) => {
    if (merchantContactsIndex === -1) {
      return primaryRole ? primaryRole : "";
    } else {
      return merchantContact[merchantContactsField.fieldId];
    }
  };
  const getFormControl = (merchantContactsField) => {
    let fieldKey = merchantContactsField.fieldId + merchantContactsIndex;
    const fieldType = merchantContactsField.fieldType;

    if (fieldType) {
      if (fieldType === "text") {
        return (
          <Form.Control
            type={merchantContactsField.fieldType}
            placeholder={merchantContactsField.placeHolder}
            id={fieldKey}
            name={merchantContactsField.fieldId}
            key={fieldKey}
            onBlur={(e) =>
              handleValidate(
                fieldKey,
                merchantContactsField.fieldId,
                e?.target?.value
              )
            }
            onChange={(e) => {
              handleValidate(
                fieldKey,
                merchantContactsField.fieldId,
                e?.target?.value
              );
              onChangeMerchantContact(
                merchantContactsField.fieldId,
                e,
                merchantContactsIndex
              );
            }}
            value={merchantContact[merchantContactsField.fieldId]}
            disabled={merchantContact?.primaryVendor}
          />
        );
      }
      if (fieldType === "select") {
        return (
          <Form.Control
            as="select"
            placeholder={merchantContactsField.placeHolder}
            id={fieldKey}
            name={merchantContactsField.fieldId}
            key={fieldKey}
            value={getRole(merchantContact, merchantContactsField)}
            defaultValue=""
            onBlur={(e) =>
              handleValidate(
                fieldKey,
                merchantContactsField.fieldId,
                e?.target?.value
              )
            }
            onChange={(e) => {
              handleValidate(
                fieldKey,
                merchantContactsField.fieldId,
                e?.target?.value
              );
              onChangeMerchantContact(
                merchantContactsField.fieldId,
                e,
                merchantContactsIndex
              );
            }}
          >
            <option value="" disabled>
              {merchantContactsField.placeHolder
                ? merchantContactsField.placeHolder
                : "Select..."}
            </option>
            {merchantContactsField.option.map((option) => (
              <option value={option.optionValue}>{option.optionName}</option>
            ))}
          </Form.Control>
        );
      }
    }

    return null;
  };

  return MerchantContactsFields.map((merchantContactsField) => {
    let fieldKey = merchantContactsField.fieldId + merchantContactsIndex;

    return (
      <Col xs={merchantContactsField.length || 3} style={{ padding: 3 }}>
        <Form.Group key={merchantContactsIndex}>
          <ToolTip
            toolTipId={merchantContactsField.toolTipId}
            customStyles="compDetailsFormLabel"
            label={merchantContactsField.fieldLabel}
            mandate={Constants.REQUIRED}
            toolTipText={merchantContactsField.toolTipText}
          />
          {getFormControl(merchantContactsField)}
          {errors && errors[fieldKey] && (
            <div key={fieldKey} style={{ color: "#d64a4a" }}>
              {errors[fieldKey]}
            </div>
          )}
        </Form.Group>
      </Col>
    );
  });
};

export default MerchantContacts;
